import React, { useState } from "react";
import { validateInputSecurity } from "../../constants/helpers/helperFunctions";

export const InputBox = ({ value, disabled, placeholder, type = "text", errorMessage, label, onChange, onInput, min = "0", register, style, isTextarea, maxHeight, height, onKeyUp, max = "" }) => {
  const [localError, setLocalError] = useState("");

  const handleChange = (e) => {
    const val = e.target.value;
    const errorMsg = validateInputSecurity(val);
    setLocalError(errorMsg);

    if (e.target.setCustomValidity) {
      e.target.setCustomValidity(errorMsg);
    }

    if (onChange) {
      onChange(e);
    }
    if (register && register.onChange) {
      register.onChange(e);
    }
  };

  const handleInput = (e) => {
    handleChange(e);
    if (onInput) {
      onInput(e);
    }
  };

  return (
    <div className="inputBoxWrapper">
      {label && <label>{label}</label>}
      {isTextarea ? (
        <textarea
          placeholder={placeholder}
          value={value}
          min={min}
          onKeyUp={() => console.log("object")}
          className=""
          disabled={disabled}
          {...register}
          onChange={handleChange}
          onInput={handleInput}
          style={{
            ...style,
            maxHeight: maxHeight,
            minHeight: "42px",
            height: height,
          }}
        />
      ) : (
        <input
          placeholder={placeholder}
          type={type}
          value={value}
          min={min}
          max={max}
          onKeyUp={onKeyUp}
          className=""
          disabled={disabled}
          {...register}
          onChange={handleChange}
          onInput={handleInput}
          style={style}
        />
      )}

      {(localError || errorMessage) && (
        <span className="error-message text-danger text-start d-block mt-1" style={{ fontSize: "12px" }}>
          {localError || errorMessage?.message || (typeof errorMessage === "string" ? errorMessage : "")}
        </span>
      )}
    </div>
  );
};

